import { render, staticRenderFns } from "./membercard_new.vue?vue&type=template&id=0fea31ae&scoped=true"
import script from "./membercard_new.vue?vue&type=script&lang=js"
export * from "./membercard_new.vue?vue&type=script&lang=js"
import style0 from "./membercard_new.vue?vue&type=style&index=0&id=0fea31ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea31ae",
  null
  
)

export default component.exports